import { MapContext } from 'App/Map/MapContext/MapContext'
import { PropertySummary } from 'App/ServiceCenter/PropertySummary/PropertySummary'
import { serviceCenterStore } from 'App/ServiceCenter/store/serviceCenterStore'
import React, { useContext, useEffect, useState } from 'react'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import { useIsWideScreen } from 'utils/useIsWideScreen'

export const PropertiesOverviewLayer = () => {
  const { map } = useContext(MapContext)
  const properties = fieldAssetStore.useSelector((s) => s.properties)
  const propertySummaries = serviceCenterStore.useSelector(serviceCenterStore.selectors.getPropertySummaries)

  const lastDownloadTime = serviceCenterStore.useSelector(
    serviceCenterStore.selectors.getOfflineContentsLastDownloadTime,
  )

  const isLoading = !lastDownloadTime
  const [openedPropertyId, setOpenedPropertyId] = useState<number | null>(null)
  const isWideScreen = useIsWideScreen()

  const closeCard = () => {
    setOpenedPropertyId(null)
  }

  useEffect(() => {
    // Click listener to close a opened card when user clicks on the map
    if (!map || !isWideScreen) return

    const clickEventListener = map.addListener('click', closeCard)

    return () => {
      google.maps.event.removeListener(clickEventListener)
    }
  }, [map])

  if (!map) return null

  return (
    <>
      {Object.entries(properties || {}).map(([propertyId, property]) => (
        <PropertySummary
          opened={openedPropertyId === +propertyId}
          onToggleOpen={() => setOpenedPropertyId((prev) => (prev === +propertyId ? null : +propertyId))}
          key={propertyId}
          property={property}
          summaryData={propertySummaries[propertyId]}
          loading={isLoading}
        />
      ))}
    </>
  )
}
